<!-- prettier-ignore -->
<div>
  @if (data.iconName) {
    <div class="dialog-icon">
      <app-icon
        [name]="data.iconName"
        height="65px"
        width="65px"
        color="var(--color-gray-400)"
      ></app-icon>
    </div>
  }

  <mat-dialog-content class="dialog-message">
    @for (line of data.message; track $index) {
      <p>{{ line }}</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-raised-button
      type="button"
      [mat-dialog-close]="true"
      class="button--primary"
    >
      {{ data.primaryText }}
    </button>

    <button
      mat-button
      type="button"
      mat-dialog-close
      class="button--secondary"
      cdkFocusInitial
    >
      {{ data.secondaryText }}
    </button>
  </mat-dialog-actions>
</div>
